import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SocialTagsService } from 'src/app/core/services/social-tags-service.service';
import { GOOGLEADS } from 'src/app/shared/components/template-slot/template-slot.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-calculator-tax',
  templateUrl: './calculator-tax.component.html',
  styleUrls: ['./calculator-tax.component.scss']
})
export class CalculatorTaxComponent implements OnInit {

  result: any = null;
  googleAds = GOOGLEADS;

  readonly tagSocialTitle: string = 'iTAX แอปคำนวณ/วางแผนภาษี';
  readonly tagSocialDescription: string = 'คำนวณภาษีเงินได้บุคคลธรรมดา อัพเดตล่าสุด';
  readonly urlPrefix: string = environment.mainBaseUrl;

  constructor(
    private router: Router,
    private meta: Meta,
    private title: Title,
    private tagsService: SocialTagsService,
  ) {
    this.title.setTitle('โปรแกรมคำนวณภาษี เงินเดือนเท่านี้ เสียภาษีกี่บาท');
    this.meta.updateTag({
      name: 'title',
      content: 'โปรแกรมคำนวณภาษี เงินเดือนเท่านี้ เสียภาษีกี่บาท'
    });
    this.meta.updateTag({
      name: 'description',
      content: 'ดาวน์โหลดแอป iTAX ฟรี ลดหย่อนภาษีสูงสุด รองรับรายได้ทุกประเภท อัพเดตค่าลดหย่อนล่าสุด'
    });
    this.tagsService.setTitleAndTags({
      tagSocialDescription: this.tagSocialDescription,
      tagSocialTitle: this.tagSocialTitle,
      urlPrefix: this.urlPrefix
    });
  }

  ngOnInit(): void {
  }
  
  onCalChange(item): any {
    this.result = item;
    const fm = Object.keys(item).map(key => key + '=' + item[key]).join('&');
    this.router.navigate(['./lite-result'], {fragment: fm});
  }
}
